export const EDIT_CREATE_PARENT = 'EDIT_CREATE_PARENT'

export const setCreateEditParent = (data) => {
    return {
        type: EDIT_CREATE_PARENT,
        payload: data
    }

}